// extracted by mini-css-extract-plugin
export default {"mobile":"home_mobile__FDRqz","mobileRow":"home_mobileRow__3nB0m","grayArea":"home_grayArea__HsWnb"};